import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.5 2.75C2.5 2.33579 2.16421 2 1.75 2C1.33579 2 1 2.33579 1 2.75V21.25C1 21.6642 1.33579 22 1.75 22H20C20.4142 22 20.75 21.6642 20.75 21.25C20.75 20.8358 20.4142 20.5 20 20.5H2.5V2.75Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.2803 7.78033C22.5732 7.48744 22.5732 7.01256 22.2803 6.71967C21.9874 6.42678 21.5126 6.42678 21.2197 6.71967L15.5 12.4393L11.7803 8.71967C11.4874 8.42678 11.0126 8.42678 10.7197 8.71967L4.71967 14.7197C4.42678 15.0126 4.42678 15.4874 4.71967 15.7803C5.01256 16.0732 5.48744 16.0732 5.78033 15.7803L11.25 10.3107L14.9697 14.0303C15.2626 14.3232 15.7374 14.3232 16.0303 14.0303L22.2803 7.78033Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgGraph;
